import {apiClient} from '../api'

export const apiAuthLogin = (username, password) => {
    return apiClient.post(process.env.REACT_APP_PHASE2_PATH_PREFIX + '/user-login/login', {
        username: username,
        password: password,
    })
}

export const apiAuthSchedule = scheduleParam => {
    return apiClient.get('/usr-common/getschedule', {
        params: scheduleParam,
    })
}

export const apiAuthRouter = (roleId, menuSystem) => {
    if (process.env.REACT_APP_PHASE2_PATH_PREFIX)
        //  Implement for UAT Phase1 & Phase2 lunch together.
        return apiClient.post('/security/permission/menu-routing', {
            roleId: roleId,
            menu_system: menuSystem
        })
    else return apiClient.post('/usr-common/getMenuRouting', {roleId: roleId})
}

export const apiAuthDataScope = roleId => {
    return apiClient.get('/security/permission/role-data-scope', {
        params: {
            role_id: roleId,
        },
    })
}

export const apiNewTokenByRole = roleId => {
    return apiClient.post('/security/myadmin-user/re-generate-token', {
        role_id: roleId,
    })
}

export const apiAuthActionScope = (routeCode, roleId, menuId) => {
    return apiClient.get('/security/permission/role-action-scope', {
        params: {
            route_code: routeCode,
            role_id: roleId,
            menu_id: menuId,
        },
    })
}

export const apiSaveOAuthData = saveLog => {
    return apiClient.post('/security/oauth/save-authorize-data', saveLog)
}

export const apiGetUserMenu = params => {
    //return apiClient.get('/user-login/getMenusByRoleId', {params: params})
    return apiClient.get('/security/userAuthProfile/getUserMenu', {params: params})
}

export const apiSubScreenActionScope = (routeCode, roleId) => {
    return apiClient.get('/security/permission/sub-screen-action-scope', {
        params: {
            route_code: routeCode,
            role_id: roleId,
        },
    })
}

export const apiVerifyAccessToken = (accesstoken) => {
    return apiClient.post('/security/token/verify-accesstoken', {
        accesstoken: accesstoken
    })
}